var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.2962 10.6456C20.2962 13.3004 19.2416 15.8465 17.3643 17.7237C15.4871 19.6009 12.9411 20.6556 10.2863 20.6556C7.63148 20.6556 5.08542 19.6009 3.2082 17.7237C1.33098 15.8465 0.276367 13.3004 0.276367 10.6456C0.276367 7.99086 1.33098 5.4448 3.2082 3.56758C5.08542 1.69035 7.63148 0.635742 10.2863 0.635742C12.9411 0.635742 15.4871 1.69035 17.3643 3.56758C19.2416 5.4448 20.2962 7.99086 20.2962 10.6456ZM15.3288 6.8544C15.2394 6.76533 15.133 6.69521 15.0159 6.64821C14.8988 6.60122 14.7734 6.57832 14.6472 6.58089C14.5211 6.58346 14.3968 6.61144 14.2817 6.66317C14.1666 6.71489 14.0631 6.78929 13.9774 6.88192L9.63188 12.4187L7.01303 9.79856C6.83514 9.6328 6.59985 9.54255 6.35673 9.54684C6.11362 9.55113 5.88165 9.64962 5.70972 9.82156C5.53778 9.99349 5.43929 10.2255 5.435 10.4686C5.43072 10.7117 5.52096 10.947 5.68672 11.1249L8.9975 14.4369C9.08669 14.5259 9.1929 14.5961 9.30979 14.6432C9.42668 14.6903 9.55186 14.7133 9.67785 14.711C9.80385 14.7087 9.92809 14.681 10.0432 14.6296C10.1582 14.5782 10.2618 14.5042 10.3476 14.4119L15.3425 8.1682C15.5128 7.99115 15.6069 7.75438 15.6045 7.50874C15.6022 7.2631 15.5036 7.02817 15.33 6.8544H15.3288Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOkIcon);
export default __webpack_public_path__ + "static/media/okIcon.58a8802e28e5a0eda3d72020846e478a.svg";
export { ForwardRef as ReactComponent };